<template>
  <header class="shop-header">
    <Logo class="shop-header__logo" />
    <div class="shop-header__nav-buttons" v-if="!isOnePlanAvailable">
      <router-link
        v-if="showHeaderBackBtn"
        :to="{ name: 'shop' }"
        class="btn btn--secondary header__cta"
      >
        {{ backBtnLabel }}
      </router-link>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import Logo from '@/assets/icons/ine-logo.svg'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'ShopHeader',
  mixins: [routesRules],
  components: {
    Logo: { ...Logo, name: 'Logo' },
  },
  computed: {
    ...mapState({
      isOnePlanAvailable: state => state.products.isOnePlanAvailable,
    }),
    backBtnLabel() {
      if (this.isBooGoPage) return 'See all plans'
      return 'Back to shop'
    },
  },
}
</script>

<style lang="scss" scoped>
.shop-header {
  width: 100%;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: var(--charcoal-gradient);
  z-index: 3;
  display: flex;
  justify-content: space-between;
  font-family: var(--font-regular);
  padding: 20px;
  @include tablet {
    padding: 20px 50px;
  }
  &__logo {
    width: 85px;
  }
  &__nav-buttons {
    @include mobile {
      display: flex;
      gap: 10px;
    }
  }
}
</style>
